"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const function_1 = require("fp-ts/lib/function");
const io_ts_1 = require("io-ts");
const Ord_1 = require("fp-ts/lib/Ord");
const Semigroup_1 = require("fp-ts/lib/Semigroup");
const Eq_1 = require("fp-ts/lib/Eq");
exports.opaqueOf = (_x) => (type) => ({
    Type: type,
    wrap: function_1.identity,
    unwrap: function_1.identity
});
exports.opaqueWithTC = (_x) => (type, s, o, sg) => (Object.assign(Object.assign(Object.assign(Object.assign({}, s), o), sg), { Type: type, wrap: function_1.identity, unwrap: function_1.identity }));
exports.opaqueOfTC = exports.opaqueWithTC('');
exports.opaque = exports.opaqueOf('');
exports.opaqueOfNumber = () => exports.opaqueWithTC('')(io_ts_1.number, Eq_1.eqNumber, Ord_1.ordNumber, Semigroup_1.semigroupSum);
exports.opaqueOfString = () => exports.opaqueWithTC('')(io_ts_1.string, Eq_1.eqString, Ord_1.ordString, Semigroup_1.semigroupString);
//# sourceMappingURL=opaque.js.map


//////////////////
// WEBPACK FOOTER
// ../models/dist/framework/opaque.js
// module id = 143
// module chunks = 12